import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import axios from "axios";
import "./../styles/PagLRStyle.css";
import UserService from "../services/User.service";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export default class PagRegister extends Component {
    state = {
        email: "",
        password: "",
        username: "",
        isLogged: false,
    };

    changeTextHandler = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        });
    };
    onSubmitHandler = async (e) => {
        e.preventDefault();

        if(this.state.email === "" || this.state.password === "" || this.state.username === "") {
            alert("Tenés que ingresar tu email, nombre y contraseña");
        } else {
            const data = {
                email: this.state.email,
                password: this.state.password,
                name: this.state.username,
            };
            const response = await UserService.register(data);

            if (response.data.message === 'SING_UP_SUCCESSFUL') {
                this.setState({ isLogged: true });
            } else {
                alert(`Error: ${response.data.message}`);
            }
        }
    };

    async componentDidMount() {
        const response = await axios.get(`${SERVER_URL}/api/isLoggedIn`, { withCredentials: true });
        this.setState({ isLogged: response.data.isLoggedIn });
    }
    render() {
        return this.state.isLogged ? (
            <Redirect to="/user/razones" />
        ) : (
            <div className="LoginSingUpScreen">
                <div className="card card-800" id="LogSingContent">
                    <div id="SingUp">
                        <div className="body-card">
                            <div className="info-card">
                                <h1>Registrarse</h1>
                                <p>
                                    Registrate para poder conseguir un mejor servicio, solo tomara
                                    unos pocos minutos.
                                </p>
                            </div>
                            <form action="/singup" method="POST">
                                <div className="row">
                                    <div
                                        className="input-field col"
                                        style={{ gridColumn: "1/3" }}
                                    >
                                        <i className="material-icons-round prefix">email</i>
                                        <input
                                            onChange={this.changeTextHandler}
                                            type="email"
                                            className="input"
                                            name="email"
                                            placeholder="Email"
                                            required
                                        />
                                    </div>
                                    <div className="input-field col bottomFields">
                                        <i className="material-icons-round prefix">person</i>
                                        <input
                                            onChange={this.changeTextHandler}
                                            type="text"
                                            className="input"
                                            name="username"
                                            placeholder="Nombre o apodo"
                                            required
                                        />
                                    </div>
                                    <div className="input-field col bottomFields">
                                        <i className="material-icons-round prefix">lock</i>
                                        <input
                                            onChange={this.changeTextHandler}
                                            type="password"
                                            className="input"
                                            name="password"
                                            placeholder="Contraseña"
                                            required
                                        />
                                    </div>
                                </div>
                                <button
                                    onClick={this.onSubmitHandler}
                                    className="btn"
                                    type="submit"
                                    name="submitlog"
                                >
                                    Listo<i className="material-icons-round right">send</i>
                                </button>
                            </form>
                        </div>
                        <div className="end-card">
                            <Link className="end-link" id="toLogin" to="/login">
                                INICIAR SESIÓN
                            </Link>
                            <Link className="CancelButton" to="/">
                                CANCELAR
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
